<div class="close-button-container" align="right">
  <mat-icon class="close-button mat-icon" aria-hidden="true" data-mat-icon-type="font" (click)="handleCancel()"
    >close</mat-icon
  >
</div>
<h2 mat-dialog-title class="title" align="center">Video Effects</h2>

<mat-dialog-content>
  <div class="video-wrapper">
    <app-camera [previewEffects]="previewEffects"></app-camera>
  </div>
  <div class="flex justify-center m-t-20 m-b-20 effects-selection">
    <button
      class="m-r-10"
      mat-mini-fab
      color="secondary"
      [ngClass]="{ active: mode === VideoEffectsMode.NONE }"
      matTooltip="No Effects"
      (click)="handleNoEffectsClick()"
    >
      <mat-icon>blur_off</mat-icon>
    </button>
    <button
      class="m-r-10 m-l-10"
      mat-mini-fab
      color="secondary"
      [ngClass]="{ active: mode === VideoEffectsMode.BLUR }"
      matTooltip="Background Blur"
      (click)="handleBlurClick(3)"
    >
      <mat-icon style="font-weight: 200" class="blur-on">blur_on</mat-icon>
    </button>
    <button
      class="m-l-10"
      mat-mini-fab
      color="secondary"
      [ngClass]="{ active: mode === VideoEffectsMode.BACKGROUND_IMAGE }"
      matTooltip="Background Image"
      (click)="handleImageBackgroundModeClick()"
    >
      <mat-icon>image</mat-icon>
    </button>
  </div>
  @if (blurSelected) {
    <div class="blur-controls">
      <div class="blur-text">Blur Level</div>
      <mat-slider min="1" max="9" step="1" #ngSlider
        ><input
          matSliderThumb
          [value]="blurRadius"
          (input)="onBlurChange({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })"
          #ngSliderThumb="matSliderThumb"
      /></mat-slider>
    </div>
  }
  @if (imageBackgroundSelected) {
    <div class="flex flex-wrap gap-10 background-images">
      @for (image of backgroundImages; track image) {
        <div>
          <img
            [attr.aria-label]="image.text"
            [src]="image.url"
            [matTooltip]="image.text"
            class="background-image"
            [ngClass]="{ selected: backgroundImage === image.url }"
            (click)="handleBackgroundImageClick(image.url)"
            loading="lazy"
            [alt]="image.text"
            [title]="image.text"
          />
        </div>
      }
    </div>
  }
</mat-dialog-content>

<div mat-dialog-actions align="end">
  <button data-testid="video-effects-cancel" mat-button (click)="handleCancel()">Cancel</button>
  <button class="primary-button" data-testid="video-effects-apply" mat-flat-button (click)="handleApply()">
    Apply
  </button>
</div>
